import React from 'react';

import { Box, FormLabel, Stack, TextField } from '@mui/material';

import AIGeneratorButton from '~/components/AIGenerator/AIGenerateButton';
import MarkdownEditor from '~/components/Common/MarkdownEditor';

import type { OfferBuilderRoom } from '../types';

interface Props {
  onChange: (nextRoomValues: Partial<OfferBuilderRoom>) => void;
  propertyName: string;
  room: OfferBuilderRoom;
}

export default function DetailsTab({ onChange, propertyName, room }: Props) {
  const aiContext = {
    model: 'room-type',
    field: 'description',
    propertyName,
    roomName: room.name || '',
  };

  return (
    <Stack spacing={3}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: 2,
        }}
      >
        <Stack spacing={1}>
          <FormLabel required>Name</FormLabel>
          <TextField
            value={room.name || ''}
            size="small"
            fullWidth
            required
            error={!room.name?.trim()}
            onChange={(event) => onChange({ name: event.target.value })}
          />
        </Stack>
      </Box>

      <Stack spacing={1}>
        <FormLabel>Description</FormLabel>
        <Box sx={{ '& .rdw-editor-main': { minHeight: 180 } }}>
          <MarkdownEditor
            value={room.description || ''}
            placeholder="Describe the room, its size, view, bedding, and what makes it distinctive."
            wrapperId={`offer-builder-room-description-${room.id || room.name || 'room'}`}
            onBlur={(description) => onChange({ description })}
          />
        </Box>
        <AIGeneratorButton
          context={aiContext}
          content={room.description}
          buttonLabel="Rewrite with AI"
          updateContext={() => aiContext}
          onChoose={(description) => onChange({ description })}
        />
      </Stack>
    </Stack>
  );
}
